module.exports = __webpack_public_path__ + "img/al1.1dd86e88.png";